import {
  CreatePixCharge,
  CreateBankingBilletCharge,
  CreateCreditCardCharge,
  PixChargeResponse,
  BankingBilletChargeResponse,
  CreditCardChargeResponse,
  UpdatePaymentMethodRequest
} from "../../Models/Payment";
import api from "../axios";

export const paymentService = {
  createPixCharge: async (data: CreatePixCharge): Promise<PixChargeResponse | null> => {
    const response = await api.post('/payment/pix', data);
    return response.data;
  },

  createBankingBilletCharge: async (data: CreateBankingBilletCharge): Promise<BankingBilletChargeResponse | null> => {
    const response = await api.post('/payment/banking-billet', data);
    return response.data;
  },

  createCreditCardCharge: async (data: CreateCreditCardCharge): Promise<CreditCardChargeResponse | null> => {
    const response = await api.post('/payment/credit-card', data);
    return response.data;
  },

  retryCreditCardCharge: async (data: { chargeId: string; orderId: string; paymentToken: string; installments: number; maskedCardNumber: string; }): Promise<CreditCardChargeResponse | null> => {
    const response = await api.post('/payment/credit-card/retry', data);
    return response.data;
  },

  updatePaymentMethod: async (data: UpdatePaymentMethodRequest): Promise<boolean> => {
    const response = await api.post('/payment/update-method', data);
    return response.data;
  },

};
